import cs from 'classnames';
import { CSSProperties } from 'react';

import './Loading.scss';

type LoadingHeight = number | 'full' | string;

interface LoadingProps {
  /** 높이. 숫자=vh, 'full'=화면 전체, 그 외 문자열=CSS 값(예 '8rem'). 기본 70 */
  height?: LoadingHeight;
}

function resolveHeight(height: LoadingHeight): string {
  if (height === 'full') {
    return '100dvh';
  }
  return typeof height === 'number' ? `${height}vh` : height;
}

/** hs 모양의 로딩 원. 앱이 처음 뜰 때와 화면 코드를 받는 동안(Suspense) 셸 밖에서 쓴다 */
export default function Loading({ height = 70 }: LoadingProps) {
  const style: CSSProperties = { height: resolveHeight(height) };

  return (
    <div className={cs('Loading', { full: height === 'full' })} style={style}>
      <span className="ring" />
    </div>
  );
}
